var map = {
	"./2co.png": 67690,
	"./alipay.png": 50494,
	"./alipay2.png": 37934,
	"./amazon.png": 11464,
	"./american_express.png": 18339,
	"./american_express_black.png": 21279,
	"./american_express_gold.png": 90082,
	"./american_express_green.png": 479,
	"./american_express_platinum.png": 3764,
	"./asia_pay.png": 18525,
	"./asia_pay2.png": 56283,
	"./bank_of_america.png": 17873,
	"./cash.png": 55737,
	"./cashu.png": 84656,
	"./chase.png": 84216,
	"./check.png": 56538,
	"./china_union.png": 44987,
	"./cirrus.png": 50808,
	"./cirrus2.png": 74232,
	"./citybank.png": 82899,
	"./clickandbuy.png": 47175,
	"./credit_card.png": 19702,
	"./credit_cards.png": 39711,
	"./currency_baht_sign.png": 39945,
	"./currency_bitcoin_sign.png": 89340,
	"./currency_denar_sign.png": 53370,
	"./currency_dinar_sign.png": 48382,
	"./currency_dollar_sign.png": 31726,
	"./currency_dollar_sign2.png": 8062,
	"./currency_euro_sign.png": 85085,
	"./currency_peso_sign.png": 94173,
	"./currency_pound_sign.png": 65940,
	"./currency_rial_sign.png": 32424,
	"./currency_ruble_sign.png": 75272,
	"./currency_rupee_sign.png": 32615,
	"./currency_sign.png": 73421,
	"./currency_yen_sign.png": 31134,
	"./currency_yen_sign2.png": 20142,
	"./currency_yuan_sign.png": 70585,
	"./diners_club.png": 40652,
	"./discover.png": 79701,
	"./e_check.png": 54722,
	"./electroncash.png": 44775,
	"./eps.png": 6004,
	"./gift_card.png": 20757,
	"./giropay.png": 39487,
	"./google_wallet.png": 39029,
	"./jcb.png": 67719,
	"./maestro.png": 99965,
	"./maestro2.png": 81435,
	"./mastercard.png": 880,
	"./mastercard2.png": 85824,
	"./mastercard_gold.png": 18251,
	"./mastercard_platinum.png": 83385,
	"./obopay.png": 89800,
	"./paymate.png": 13603,
	"./paymate2.png": 81753,
	"./paypal.png": 26013,
	"./purchase_order.png": 61620,
	"./skrill.png": 55261,
	"./transferwise.png": 3853,
	"./ukash.png": 57030,
	"./visa.png": 99607,
	"./visa_electron.png": 14438,
	"./visa_gold.png": 64422,
	"./visa_platinum.png": 80096,
	"./webmoney.png": 79222,
	"./western_union.png": 22368,
	"./wire_transfer.png": 2589,
	"./worldpay.png": 45142,
	"./xoom.png": 43303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78464;